export function getCheckoutDraftStorageKey(
  user: { id?: unknown; email?: unknown } | null,
): string {
  if (user?.id !== undefined && user.id !== null) {
    return `brocom_checkout_draft:user:${user.id}`;
  }
  if (typeof user?.email === 'string' && user.email.trim()) {
    return `brocom_checkout_draft:user:${encodeURIComponent(
      user.email.trim().toLowerCase(),
    )}`;
  }
  return 'brocom_checkout_draft:guest';
}
